// @ai-generated 2026-10-08T09:40:29+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
import { EnumContainerActionRequest } from '@Model';
import { Button, defaultIconSize } from '@synqo/frontend-component-library';
import { type ComponentProps } from 'react';
import { IconArrowsExchange, IconRefresh, IconTruckReturn } from '@tabler/icons-react';

const followUps = [
    { kind: EnumContainerActionRequest.Collect, label: 'Abholen', Icon: IconTruckReturn, removes: true },
    { kind: EnumContainerActionRequest.Empty, label: 'Leeren', Icon: IconRefresh, removes: false },
    { kind: EnumContainerActionRequest.Exchange, label: 'Tauschen', Icon: IconArrowsExchange, removes: true },
] as const;

interface FollowUpButtonsProps {
    allowedFollowUps: readonly EnumContainerActionRequest[];
    /** Whether a follow-up is being prepared, which keeps another from being asked for. */
    locked: boolean;
    onFollowUp: (kind: EnumContainerActionRequest) => void;
    size?: ComponentProps<typeof Button>['size'];
    /** Why the buttons are locked, shown on hover. */
    tooltip?: string;
    /** Why pickup and swap are locked because the container already leaves; both stay open without it. */
    leavingHint?: string;
}

/** One button per follow-up the server allows. */
export function FollowUpButtons({
    allowedFollowUps,
    locked,
    onFollowUp,
    size,
    tooltip,
    leavingHint,
}: FollowUpButtonsProps) {
    return (
        <>
            {followUps
                .filter(({ kind }) => allowedFollowUps.includes(kind))
                .map(({ kind, label, Icon, removes }) => (
                    <Button
                        key={kind}
                        variant="success"
                        size={size}
                        locked={locked || (removes && !!leavingHint)}
                        tooltip={removes && !locked && leavingHint ? leavingHint : tooltip}
                        onClick={() => onFollowUp(kind)}
                    >
                        <Icon size={defaultIconSize} />
                        &nbsp;{label}
                    </Button>
                ))}
        </>
    );
}
